import { createActions } from 'redux-actions';

export const actions = createActions(
  'FETCH_SHIPPING_RATES',
  'SHIPPING_RATES_RESPONSE',
  'POST_SHIPPING_PREFERENCE',
  'SHIPPING_PREFERENCE_RESPONSE'
);
